import React, { Component } from 'react';
import { Button, InfoLabel } from '../../../../common/components';
import { Row, Col } from 'react-bootstrap';
import { InternalButtonBar } from '../../../layout/components/InternalButtonBar/InternalButtonBar';

class BrokerMessageDetails extends Component {
  createTracking = () => {
    const { brokerMessage, createTrackingLinkFromMessage } = this.props;

    const values = {
      data: {
        attributes: {
          name: brokerMessage.data.attributes.company,
          trading_name: brokerMessage.data.attributes.company,
          branch_name: '',
          broker_type: 'tracking',
          phone_number: brokerMessage.data.attributes.phone,
          metadata: {
            display_phone_number: brokerMessage.data.attributes.phone,
          },
        },
      },
    };

    createTrackingLinkFromMessage(values);
  };

  render() {
    const { brokerMessage } = this.props;
    const buttons = () => {
      return [
        {
          type: 'policy',
          permissions: ['broker.create'],
          button: (
            <Button
              label="Create Tracking Link"
              bsStyle="primary"
              className="pull-right"
              key="create-tracking"
              handleClick={this.createTracking}
            />
          ),
        },
      ];
    };

    return (
      <>
        <h4>Broker Message - {brokerMessage.data.attributes.reference} </h4>
        <Row>
          <Col sm={12}>
            <InfoLabel
              label="Business Type:"
              labelSize={4}
              value={brokerMessage.data.attributes.business_type}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <InfoLabel
              label="Name:"
              labelSize={4}
              value={brokerMessage.data.attributes.name}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <InfoLabel
              label="Company:"
              labelSize={4}
              value={brokerMessage.data.attributes.company}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <InfoLabel
              label="Email:"
              labelSize={4}
              value={brokerMessage.data.attributes.email}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <InfoLabel
              label="Telephone:"
              labelSize={4}
              value={brokerMessage.data.attributes.phone}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <InfoLabel
              label="Comments:"
              labelSize={4}
              value={brokerMessage.data.attributes.message}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <InternalButtonBar buttons={buttons()} />
          </Col>
        </Row>
      </>
    );
  }
}

export default BrokerMessageDetails;
